export class UtilParam {
    name: string;
    dataSource: string;
}
